import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import PageHero from './PageHero';
import PageHeroCarousel from './PageHeroCarousel';
import PageLogoRibbon from './PageLogoRibbon';
import PageLogosRow from './PageLogosRow';
import PageSteps from './PageSteps';
import PageCallOut from './PageCallOut';
import PageCaseAndNews from './PageCaseAndNews';
import PageEvents from './PageEvents';
import PageNewsList from './PageNewsList';
import PageStatistics from './PageStatistics';
import PageText from './PageText';
import PageTextMedia from './PageTextMedia';
import PageComparisonTable from './PageComparisonTable';
import PageSubscribeNewsletter from './PageSubscribeNewsletter';
import PageFAQs from './PageFAQs';
import PageForm from './PageForm';
import PageTeaserCards from './PageTeaserCards';
import PageUSPCarousel from './PageUSPCarousel';
import PageTabs from './PageTabs';
import PageFullVideo from './PageFullVideo';
import PageCollaborationPartners from './PageCollaborationPartners';
import PageImageGrid from './PageImageGrid';

const PageBody = ({ content, selectedLocale }) =>
  content &&
  content.map((slice) => {
    let render;

    switch (slice.slice_type) {
      case 'hero':
        render = <PageHero content={slice.primary} />;
        break;

      case 'hero_carousel':
        render = <PageHeroCarousel content={slice} />;
        break;

      case 'logo_ribbon':
        render = <PageLogoRibbon selectedLocale={selectedLocale} />;
        break;

      case 'logos_row':
        render = <PageLogosRow content={slice} />;
        break;

      case 'steps':
        render = <PageSteps content={slice} />;
        break;

      case 'call_out':
        render = <PageCallOut content={slice.primary} />;
        break;

      case 'text':
        render = <PageText content={slice} />;
        break;

      case 'text_media':
        render = <PageTextMedia content={slice.primary} />;
        break;

      case 'case___news':
        render = (
          <PageCaseAndNews
            content={slice.primary}
            selectedLocale={selectedLocale}
          />
        );
        break;

      case 'statistics':
        render = <PageStatistics content={slice.primary} />;
        break;

      case 'events':
        render = <PageEvents content={slice} selectedLocale={selectedLocale} />;
        break;

      case 'news_list':
        render = (
          <PageNewsList
            content={slice.primary}
            selectedLocale={selectedLocale}
          />
        );
        break;

      case 'comparison_table':
        render = <PageComparisonTable content={slice} />;
        break;

      case 'subscibe_newsletter':
        render = <PageSubscribeNewsletter content={slice.primary} />;
        break;

      case 'faqs':
        render = (
          <PageFAQs content={slice.primary} selectedLocale={selectedLocale} />
        );
        break;

      case 'form':
        render = <PageForm content={slice.primary} />;
        break;

      case 'teaser_cards':
        render = <PageTeaserCards content={slice} />;
        break;

      case 'usp_carousel':
        render = <PageUSPCarousel content={slice} />;
        break;

      case 'tabs':
        render = <PageTabs content={slice} />;
        break;

      case 'full_video':
        render = <PageFullVideo content={slice} />;
        break;

      case 'collaboration_partners':
        render = <PageCollaborationPartners content={slice} />;
        break;

      case 'image_grid':
        render = <PageImageGrid content={slice} />;
        break;

      default:
        render = (
          <div>
            <p>Not implemented type {slice.slice_type}</p>
          </div>
        );
        break;
    }

    return <Fragment key={slice.id}>{render}</Fragment>;
  });

PageBody.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedLocale: PropTypes.string.isRequired,
};

export default PageBody;
